import { useAuth0 } from "@auth0/auth0-react";
import Button from "../../Components/Button/button";
import Image from "../../Components/Image/Image";


const NoPermissionPage = () => {
    const { logout } = useAuth0();
    return (
        <div className="h-screen w-screen flex flex-col justify-center items-center">
            <div className="flex items-center gap-4 font-bold text-[32px] text-customTextColor mb-3">
                <Image src="Lock" />
                <p>Access Denied</p>
            </div>
            <p className="font-normal text-[20px] text-customTextColor">You do not have the necessary permissions to login.</p>
            <p className="font-normal text-[20px] text-customTextColor">If you believe this is an error, please contact your system</p>
            <p className="font-normal text-[20px] text-customTextColor">administrator for assistance.</p>
            <Button text={'Go Back'} className={'px-4 w-[171px] mt-[20px]'} onClick={() => logout({ returnTo: window.location.origin })} />
        </div>
    )
}
export default NoPermissionPage;